export const toLowerTr = (input: string) => {
  if (!input) {
    return null;
  }
  var letters: any = { İ: 'i', I: 'ı', Ş: 'ş', Ğ: 'ğ', Ü: 'ü', Ö: 'ö', Ç: 'ç' };
  input = input.replace(/(([İIŞĞÜÇÖ]))/g, function (letter) {
    return letters[letter];
  });
  return input.toLowerCase();
};

export const toUpperTr = (input: string) => {
  if (!input) {
    return null;
  }
  var letters: any = { i: 'İ', ş: 'Ş', ğ: 'Ğ', ü: 'Ü', ö: 'Ö', ç: 'Ç', ı: 'I' };
  input = input.replace(/(([iışğüçö]))/g, function (letter) {
    return letters[letter];
  });
  return input.toUpperCase();
};
